import CONST from './Constant';
import axiosPrivate from '../../../../Setup/Axios/SetupAxios';
import {handleAsyncAction} from "../../../../Setup";



/****************************************
 FETCH USER STATS
 ****************************************/
export const fetchStatsSuccess = (payload) => ({
    type: CONST.FETCH_STATS_SUCCESS,
    payload: payload
});

export const fetchStatsFailed = (payload) => ({
    type: CONST.FETCH_STATS_FAILED,
    payload: payload
});

export const fetchStats = ({ dispatch }) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('core/dashboard/stats'),
        [fetchStatsSuccess],
        [fetchStatsFailed]
    );
};